<template>
  <div class="primary--text text-h2 text-md-h1 overflow-hidden">
    <span
      class="d-inline-block position-relative title-widget"
      :class="{ 'title-widget-bottom': bottom }"
    >
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    bottom: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.title-widget {
  &:before,
  &:after {
    content: "";
    height: 38px;
    margin-top: -10px;
    position: absolute;
    top: 50%;
    width: 95px;
  }

  &:before {
    background-image: url(../../assets/img/title-left.png);
    margin-right: 30px;
    right: 100%;
  }

  &:after {
    background-image: url(../../assets/img/title-right.png);
    left: 100%;
    margin-left: 30px;
  }

  &.title-widget-bottom {
    padding-bottom: 20px;

    &:before,
    &:after {
      margin-top: -40px;
      top: 100%;
    }
  }
}
</style>
